export const SET_DAYS = 'SET_DAYS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_FILTER_DATERANGE = 'SET_FILTER_DATERANGE'
export const SET_TECHNICIAN = 'SET_TECHNICIAN'
export const CALIBRATE_TECHNICIAN = 'CALIBRATE_TECHNICIAN'
export const CALIBRATE_DATESTART = 'CALIBRATE_DATESTART'
export const CALIBRATE_DATEEND = 'CALIBRATE_DATEEND'
export const SET_VIEW_BY = 'SET_VIEW_BY'
export const CALIBRATE_VIEW_BY = 'CALIBRATE_VIEW_BY'
export const CALIBRATE_SEARCH_TERM = 'CALIBRATE_SEARCH_TERM'
export const CALIBRATE_PAGE_SIZE = 'CALIBRATE_PAGE_SIZE'
export const CALIBRATE_SORT_DIR = 'CALIBRATE_SORT_DIR'
export const CALIBRATE_ORDER_BY = 'CALIBRATE_ORDER_BY'
export const CALIBRATE_FILTER_BY = 'CALIBRATE_FILTER_BY'
export const SET_CALIBRATE_SERVICE_RATES = 'SET_CALIBRATE_SERVICE_RATES'
export const INIT_CALIBRATE = 'INIT_CALIBRATE'
export const INIT_CALIBRATEEVENT = 'INIT_CALIBRATEEVENT'
export const SET_CALIBRATE = 'SET_CALIBRATE'
export const SET_CALIBRATES = 'SET_CALIBRATES'
export const UPDATE_CALIBRATE = 'UPDATE_CALIBRATE'
export const SET_CALIBRATEREQUESTS = 'SET_CALIBRATEREQUESTS'
export const SET_CALIBRATEEVENTS = 'SET_CALIBRATEEVENTS'
export const SET_CALIBRATEEVENT = 'SET_CALIBRATEEVENT'
export const SET_CALIBRATEEVENTID = 'SET_CALIBRATEEVENTID'
export const UPDATE_CALIBRATEEVENT = 'UPDATE_CALIBRATEEVENT'
export const SET_CALIBRATESTATUS = 'SET_CALIBRATESTATUS'
export const UPDATE_CALIBRATEEVENT_STATE = 'UPDATE_CALIBRATEEVENT_STATE'
export const SET_REPAIRLINES = 'SET_REPAIRLINES'
export const SET_CALIBRATEEVENT_FILEINFO = 'SET_CALIBRATEEVENT_FILEINFO'
export const SET_CALIBRATECOUNTS = 'SET_CALIBRATECOUNTS'
export const SET_CALIBRATE_CHATCOUNTS = 'SET_CALIBRATE_CHATCOUNTS'
export const SET_CALIBRATEEVENT_DIALOG = 'SET_CALIBRATEEVENT_DIALOG'
export const SET_CALIBRATEEVENT_ACTIVITY = 'SET_CALIBRATEEVENT_ACTIVITY'
export const SET_REQUEST_SERVICES = 'SET_REQUEST_SERVICES'
export const SET_SERVICE_APPROVAL = 'SET_SERVICE_APPROVAL'
export const UPDATE_REQUEST_SERVICES = 'UPDATE_REQUEST_SERVICES'
export const SET_INVOICE_PREFERENCES = 'SET_INVOICE_PREFERENCES'
export const SET_REFRESH_RATE = 'SET_REFRESH_RATE'
export const CALIBRATE_REFRESH_RATE = 'CALIBRATE_REFRESH_RATE'
export const SET_LOCATION_CALIBRATES = 'SET_LOCATION_CALIBRATES'
export const UPDATE_PENDING_SERVICE_IDS = 'UPDATE_PENDING_SERVICE_ID'
export const CLEAR_PENDING_SERVICE_IDS = 'CLEAR_PENDING_SERVICE_IDS'
export const SET_SHOW_ALL = 'SET_SHOW_ALL'
export const SET_SCANS = 'SET_SCANS'
export const ADD_TO_SCANS = 'ADD_TO_SCANS'
export const RESET_CREDIT = 'RESET_CREDIT'
export const SET_CREDIT = 'SET_CREDIT'
export const SET_PENDING_STATUS_CHANGE_OBJECT = 'SET_PENDING_STATUS_CHANGE_OBJECT'
export const SET_PRICINGRULERESULTS = 'SET_PRICINGRULERESULTS'



// WEBPACK FOOTER //
// ./src/store/modules/calibrates/types.js